import MainLayout from '@/layout/main-layout.vue'
import ContentLayout from '@/layout/content-layout.vue'

export const ROUTER_LOGIN_SSO = "login-sso";
export const ROUTER_LOGIN = "login";
export const ROUTER_NAME_HOME = "home-index";
export const ROUTER_NAME_404 = 'error-404';
export const ROUTER_NAME_403 = 'error-403';

export const routers = [
  {
    path: '/',
    component: MainLayout,
    redirect: '/login',
    children: [
      {
        path: '/home',
        meta: { title: '首页' },
        name: ROUTER_NAME_HOME,
        component: resolve => {
          require(['@/views/home.vue'], resolve);
        }
      },
      {
        path: 'personal-income-tax',
        name: 'personal-income-tax',
        component: ContentLayout,
        children: [
          {
            path: 'personal-info',
            meta: { title: '人员信息采集' },
            name: 'personal-info',
            component: resolve => {
              require(['@/views/personal-income-tax/personal-info/index.vue'], resolve);
            }
          },
          {
            path: 'personal-pension-payment-info',
            meta: { title: '个人养老金缴费信息采集' },
            name: 'personal-pension-payment-info',
            component: resolve => {
              require(['@/views/personal-income-tax/personal-pension-payment-info/index.vue'], resolve);
            }
          },
          {
            path: 'special-additional-deductions',
            meta: { title: '专项附加扣除信息采集' },
            name: 'special-additional-deductions',
            component: resolve => {
              require(['@/views/personal-income-tax/special-additional-deductions/index.vue'], resolve);
            }
          },
          {
            path: 'consolidated-income-tax-statement',
            meta: { title: '综合所得申报' },
            name: 'consolidated-income-tax-statement',
            component: resolve => {
              require(['@/views/personal-income-tax/consolidated-income-tax-statement/index.vue'], resolve);
            }
          },
          {
            path: 'declaration-classified-income',
            meta: { title: '分类所得申报' },
            name: 'declaration-classified-income',
            component: resolve => {
              require(['@/views/personal-income-tax/declaration-classified-income/index.vue'], resolve);
            }
          },
          {
            path: 'tax-payment',
            meta: { title: '税款缴纳' },
            name: 'tax-payment',
            component: resolve => {
              require(['@/views/personal-income-tax/tax-payment/index.vue'], resolve);
            }
          }
        ]
      },
      
    ]
  },
  {
    path: '/login',
    meta: { title: '自然人电子税务局' },
    name: ROUTER_LOGIN,
    component: resolve => {
      require(['@/views/login.vue'], resolve);
    }
  },
  {
    path: '/login-sso',
    meta: { title: '自然人电子税务局' },
    name: ROUTER_LOGIN_SSO,
    component: resolve => {
      require(['@/views/login-sso.vue'], resolve);
    }
  },
  {
    path: '/403',
    meta: {
      title: '403-权限不足'
    },
    name: ROUTER_NAME_403,
    component: resolve => {
      require(['@//views/error-page/403.vue'], resolve);
    }
  },
  {
    path: '/404',
    name: ROUTER_NAME_404,
    meta: {
      title: '404-页面不存在'
    },
    component: resolve => {
      require(['@/views/error-page/404.vue'], resolve);
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/router.js